<sb-dialog-activation [showTitle]="true">
  <div main-panel>
    <chapter-step
      [subtitle]="'Add your first shift' | translate"
      [title]="
        ('Hello [userName]! Ready to add a shift for [companyName]?' | translate: { userName, companyName }) + '🚀'
      "
      [nextButtonLabel]="'Let\'s do it!' | translate"
      (next)="close({ action: 'primary' })"
    >
      <p class="m-0">{{ "We'll guide you step by step." | translate }}</p>
    </chapter-step>
  </div>
  <div
    class="flex size-full min-h-72 overflow-hidden rounded-lg bg-cover bg-center bg-no-repeat lg:mr-12"
    aside-panel
    [ngStyle]="{
      backgroundImage: 'url(assets/images/onboarding/chapters/schedule-shift.jpeg)',
    }"
  ></div>
</sb-dialog-activation>
